import { useState } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import { Link } from "react-router-dom";


function XTimeByDay(props)
{
       
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [view,setView] = useState('link');


 

    const [row, setRow] = useState({
        hm: '',
        day: '',
    });

 

  

    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  




    const goChange = () => {


        if(props.param1 < 1)
        {
            props.mainView.showDialog( "Ups!",  "Nie wybrano żadnej pozycji." , "ok" , null);  
            return;
        }

        setView("dialog");    
    }
    

    const closeDialog = () => {

        setRow( {...row, ['hm']: "00:00" ,  ["hm_valid"]:true } );  
        setView('link');
        console.log("goclose ");
    }




    const saveTab = () => {

            setView('link');
            console.log("goclose ");

            if(props.onChange != undefined)
                {
                    props.onChange(
                        row.day,
                        row.hm,
                        props.param1,
                        props.param2,
                        props.param3,
                        props.param4
                    );
                }

    }


 
    console.log("VV " + view);
 

 


    var dlg = null;

    if(view == 'dialog')
        {
           

            dlg = <div className="dlg_window dlg_type_y">
                    <div className="dlg_title">{props.title}</div>            

                    <div className="dlg_msg">
                        
                        
                        <div>
                           
                        </div>

                            <div className="form_tab">                                

                                <div className="form_control">
                                        <div className="fieldName">Dzień* </div>
                                        <InputDate   userData={props.userData} value={row.day} err={errTab}  valChange={valChangeListener} goNext={null} name="day" placeholder={""} className=' ' req='1'   />
                                </div>

                                <div className="form_control">
                                    <div className="fieldName">Godzina*</div>
                                    <InputTime   userData={props.userData} value={row.hm} err={errTab}  valChange={valChangeListener}  name="hm" placeholder={"Godzin: "} className=' w150 ' req='1'   />
                                </div>                                                             

                            </div>


                    </div>

                    <div className="dlg_btn">
                          <div className="btn" atr-type="save" onClick={saveTab}>Zapisz</div>
                          &nbsp;&nbsp;
                          <div className="btn" atr-type="cancel" onClick={closeDialog}>Anuluj</div>
                    </div>
            </div>
        }


 
    return (
        <span>            
             <span onClick={goChange} className="btn">Zmień godzinę</span>
             {dlg}
        </span>
    )
}

export default XTimeByDay;
